var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_43031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7017 5.82547C12.9677 7.13114 12.7781 8.48855 12.1645 9.67135C11.5508 10.8541 10.5503 11.7908 9.32959 12.3252C8.10893 12.8595 6.74197 12.9593 5.45668 12.6077C4.17138 12.2562 3.04544 11.4747 2.26662 10.3935C1.4878 9.31229 1.10318 7.99677 1.17689 6.66632C1.25061 5.33586 1.77821 4.07088 2.67171 3.08234C3.56521 2.0938 4.7706 1.44145 6.08686 1.23408C7.40312 1.0267 8.7507 1.27684 9.90485 1.94278",
    stroke: "#364153",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 6.40793L6.98984 8.15558L12.8153 2.33008",
    stroke: "#364153",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_43031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9812,
    height: 13.9812,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTick);
export default __webpack_public_path__ + "static/media/GrayTick.b8fc455873a52c84090ad76d82f7d161.svg";
export { ForwardRef as ReactComponent };